import _ from 'lodash'

Audio =
  name: 'audio'
  voice: null
  voices: []
  lang: 'en-US'
  text: null
  utterance: null

  getVoice: (voice_params) ->
    _.find(window.speechSynthesis.getVoices(), voice_params)

  getVoices: (languages) ->
    for language in languages
      lang = language || @lang
      voice = if lang == 'es'
        _.find(window.speechSynthesis.getVoices(), {name: "Google español"})
      else if lang == 'en'
        _.find(window.speechSynthesis.getVoices(), {name: "Samantha"})
      else
        _.find(window.speechSynthesis.getVoices(), {lang: "#{language}-#{language.toUpperCase()}"})
      @voices.push voice
    @voices

  loadVoices: ->
    @voices = window.speechSynthesis.getVoices()
#    console.log('@voices')
#    console.log(@voices)
    @voices

  getVoiceName: (language) ->
    voice = @getVoice(language)
    if voice
      voice.name

  speak: (text, event, language, voice_name) ->
    window.speechSynthesis.cancel()
    @utterance = new SpeechSynthesisUtterance()
    @utterance.text  = text
    @utterance.lang  = language || @lang
    @utterance.voice = @voice

    if voice_name && (!@utterance.voice || (@voice && @voice.name && @voice.name != voice_name))
      @utterance.voice = _.find(window.speechSynthesis.getVoices(), {lang: language, name: voice_name})

    if !@utterance.voice
      @utterance.voice = _.find(window.speechSynthesis.getVoices(), {lang: "#{@lang}"})

    if !@utterance.voice
      @utterance.voice = _.find(window.speechSynthesis.getVoices(), {lang: "#{@lang.substring(0,2)}"})

    @voice = @utterance.voice

    if event and event.shiftKey
      @utterance.rate = 0.6
    else
      @utterance.rate = 1
    window.speechSynthesis.speak(@utterance)

  init: () ->
    @loadVoices()
    @

`export default Audio`



// WEBPACK FOOTER //
// ./src/services/Audio.js.coffee